import React, { useEffect, useState } from "react";
import "./style.css";
import {
  getBookingFormatedDateMonthTimeValue,
  getBookingFormatedDateMonthValue,
  getBookingFormatedValue,
  getBookingFormatedValueNew,
  isTravelDateGreaterThanPointTime,
} from "../../../utils/Functions";
import DriverIcon from "../../../assets/drivericon.jpg";
import CarIcon from "../../../assets/carIcon.png";
import VerifiedIcon from "../../../assets/verifiedIcon.png";
import DriverSteering from "../../../assets/driverSteering.png";
import AndroidSeatBooking from "../../AndroidSeatBooking";
import { Chip } from "@mui/material";
import { TagColor } from "../../../utils/common.data";

const AndroidCabItem = ({
  busValue,
  id,
  name,
  images,
  departure,
  arrival,
  duration,
  rating,
  price,
  seatsAvailable,
  fetchCategories,
  viewSeatId,
  setViewSeatId,
  handleApiRedirect,  
  categoryTags
}) => {
  const [viewSeat, setViewSeat] = useState({
    open: false,
    busId: "",
    busDetail: {},
  });
  const [searchDetail, setSearchDetail] = useState({
    boarding: "",
    dropping: "",
    travel_date: "",
  });

  useEffect(() => {
    const searchData = sessionStorage.getItem("bookingdetails");
    if (searchData) {
      try {
        const searchValue = JSON.parse(searchData);
        setSearchDetail({
          ...searchDetail,
          ...searchValue,
          travel_date: searchValue?.date,
        });
      } catch (error) {
        console.log(`search Data Err`, error);
      }
    }
  }, []);

  const handleSeatView = (id) => {
    if (id === viewSeatId) {
      setViewSeat({ ...viewSeat, open: false, busId: "" });
      setViewSeatId(null);
      return;
    }
    fetchCategories();
    setViewSeat({
      busId: id,
      open: true,
      busDetail: {
        ...busValue,
        id,
        name,
        images,
        rating,
        price,
      },
    });
    setViewSeatId(id);
  };

  return (
    <section
      className={`main_cab_item_container ${
        seatsAvailable == 0 ? "main_cab_item_container_disabled" : ""
      }`}
    >
      <div className="main_cab_item_container_first">
        <aside className="main_cab_item_container_first_left">
          <aside className="main_cab_item_container_first_left_timing">
            <div className="main_cab_item_container_first_left_timing_depart">
              {getBookingFormatedValue(new Date(busValue?.departure))}
            </div>
            <div className="main_cab_item_container_first_left_timing_duration">
              {duration}
            </div>
            <div className="main_cab_item_container_first_left_timing_arrival">
              {getBookingFormatedValue(new Date(busValue?.arrival))}
              {isTravelDateGreaterThanPointTime(
                busValue?.arrival,
                busValue?.departure
              ) && <div className="extra_date_view_card"></div>}
            </div>
          </aside>
          <aside className="main_cab_item_container_first_left_location">
            <div className="text_section_main">
              <p className="text_section_main_pickup">
                {busValue?.start_location}
              </p>
              <p className="text_section_main_drop">{busValue?.end_location}</p>
            </div>
            <div className="line_wrapper">
              <div className="circle_icon_cab"></div>
              <div className="vertical_line"></div>
              <div className="circle_icon_cab circle_icon_cab_green"></div>
            </div>
          </aside>
        </aside>
        <aside className="main_cab_item_container_first_right">
          {seatsAvailable == 0 ? (
            <span>Fully Booked</span>
          ) : (
            <span>&#8377; {price}<sup className="decimal">.00</sup></span>
          )}
          {seatsAvailable !== 0 && (
            <div className="main_cab_item_container_first_right_main">
              <button
                type="button"
                className={`main_cab_item_container_first_right_main_button ${
                  viewSeatId == id ? "booking_bus_item_button_open" : ""
                }`}
                onClick={() => {
                  handleSeatView(id);
                }}
              >
                Book
              </button>
            </div>
          )}
        </aside>
      </div>
      {busValue?.cat_tags?.length > 0 && categoryTags?.length > 0 && <>
        <div className="divider_line"></div>
        <div className={`main_cab_item_container_fourth ${busValue?.driver ? "": "main_cab_item_container_fourth_padding"}`}>
        <aside className="main_cab_item_container_fourth_left">
          <div className="main_cab_item_container_fourth_left_value">
            {categoryTags?.length > 0 && categoryTags.filter((value) => busValue?.cat_tags?.includes(value?.value)).map((item, index) => {
              return (
                <Chip
                                        key={item.value}
                                        label={item?.title}
                                        sx={{backgroundColor: TagColor[index]}}
                                        className="main_cab_item_container_fourth_left_value_chips"
                                      />
              );
            })}
          </div>
        </aside>
      </div>
      </>}
      {busValue?.driver && <>
        <div className="divider_line"></div>
        <div className={`main_cab_item_container_second ${busValue?.driver?.car ? "": "main_cab_item_container_fourth_padding"}`}>
        <aside className="main_cab_item_container_second_left">
          <div className="main_cab_item_container_second_left_icon">
            <img src={DriverSteering} alt="" />
          </div>
          <div
            className={`main_cab_item_container_second_left_image ${
              busValue?.driver?.d_is_verified
                ? "main_cab_item_container_second_left_image_verify"
                : ""
            }`}
          >
            {busValue?.driver?.d_profile_image_path ? (
              <img
                className="main_cab_item_container_second_left_image_tag"
                src={`${process.env.REACT_APP_BACKEND_IMAGE_URL}${busValue?.driver?.d_profile_image_path}`}
                alt=""
                onError={(e) => {
                  e.target.onerror = null; // prevent infinite loop if default image also fails
                  e.target.src = DriverIcon; // set fallback image
                }}
              />
            ) : (
              <img
                className="main_cab_item_container_second_left_image_tag"
                src={DriverIcon}
                alt={busValue?.driver?.d_name}
              />
            )}
            {busValue?.driver?.d_is_verified && (
              <span className="main_cab_item_container_second_left_image_verify_icon">
                <img src={VerifiedIcon} alt="Verified" />
              </span>
            )}
          </div>
          <div className="main_cab_item_container_second_left_heading">
            <div className="main_cab_item_container_second_left_heading_title">
              {busValue?.driver?.d_name}
            </div>
            <div className="main_cab_item_container_second_left_heading_rating">
              <i className="fas fa-star"></i>{" "}
              <span>{busValue?.driver?.d_rating}</span>
              <span>- {busValue?.driver?.d_rating_count} ratings</span>
            </div>
          </div>
        </aside>
        <aside className="main_cab_item_container_second_right"></aside>
      </div>
      </>}
      {busValue?.driver?.car && <><div className="divider_line"></div>
      <div className={`main_cab_item_container_third`}>
        <aside className="main_cab_item_container_third_left">
          <div className="main_cab_item_container_third_right_icon">
            <i className="fas fa-car-alt"></i>
          </div>
          <div
            className={`main_cab_item_container_third_left_image`}
          >
            {busValue?.driver?.car?.car_image_path ? (
              <img
                className="main_cab_item_container_third_left_image_tag"
                src={`${process.env.REACT_APP_BACKEND_IMAGE_URL}${busValue?.driver?.car?.car_image_path}`}
                alt=""
                onError={(e) => {
                  e.target.onerror = null; // prevent infinite loop if default image also fails
                  e.target.src = CarIcon; // set fallback image
                }}
              />
            ) : (
              <img
                className="main_cab_item_container_third_left_image_tag"
                src={CarIcon}
                alt={busValue?.driver?.d_name}
              />
            )}
          </div>
          <div className="main_cab_item_container_third_right_name">
            {busValue?.driver?.car?.car_name}({busValue?.driver?.car?.car_model})
            {busValue?.driver?.car?.car_color &&<div className="passenger_detail_main_cab_item_container_third_right_name">
                                  {busValue?.driver?.car?.car_color}
                                </div>}
          </div>
        </aside>
        <aside className="main_cab_item_container_third_right"></aside>
      </div></>}
      {id == viewSeatId && (
        <AndroidSeatBooking
          busSelect={{ ...viewSeat.busDetail, ...busValue }}
          fetchCategories={fetchCategories}
          handleApiRedirect={handleApiRedirect}
        />
      )}
    </section>
  );
};

export default AndroidCabItem;
